import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { withHandlers } from 'recompose';
import { compose } from 'ramda';

import connect from 'app/libs/connect';
import BasicLink from 'app/components/Links/BasicLink.styled';
import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';
import { HOME_URL } from 'app/router/constants/externalUrls';
import { BOTTOM } from 'app/analytics/constants/positions';
import translations from 'app/features/localization/translations.json';
import { homeSelected } from 'app/features/header/actions';

const UI = ({ onClick }) => (
  <FormattedMessage
    data-t="continue-exploring"
    id="landing_alternative_link_continue_exploring"
    values={{
      continueExploring: (
        <BasicLink as={LocalizedLink} to={HOME_URL} onClick={onClick}>
          <FormattedMessage id="landing_continue_exploring" />
        </BasicLink>
      ),
    }}
  />
);

UI.propTypes = { onClick: PropTypes.func.isRequired };

const onClick =
  ({ homeSelected }) =>
  () => {
    homeSelected({
      position: BOTTOM,
      textOfButtonOrLink: translations.landing_continue_exploring,
    });
  };

const ContinueExploring = compose(
  connect(null, { homeSelected }),
  withHandlers({ onClick }),
)(UI);

export { UI, onClick };

export default ContinueExploring;
